import React, { Component, useState } from 'react';
import { Table, Row, Button, Modal, Select, Form, Radio, Col, message, Input, Carousel, Pagination, Avatar } from 'antd';
import { api, app } from "../../app";
import config from "../../config";
import "./index.css";

class CaseAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            data_loding: false,
            detailData: {},
            progress_list: [],
            teamList: [],
            isShow: false,
            isShow2: false,
            isShow3: false,
            news_type: '1',
            total: 0,
            page: 1,
            status: '-1',
            progress_status: '-1',
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 14,
                },
            },
            buttonItemLayout: {
                wrapperCol: {
                    span: 14,
                    offset: 4,
                },
            },
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // 获取详情
    getDetail(e) {
        console.log(e);
        const _this = this;
        console.log(_this)
        console.log(_this.props);
        const hide = message.loading('loading..');
        app.post(api.GetAdminCaseReportDetail, {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            case_report_id: e,
        }).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                hide();
                if (flag === 1) {
                    // _this.detailData = data;
                    _this.setData({
                        detailData: data,
                        progress_list_reson: data.progress_list.length > 0 ? data.progress_list[0].desc : ''
                    })
                    _this.handleShow();
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    // 显示或隐藏弹窗(案件详情)
    handleShow = () => {
        if (this.state.isShow) {
            this.setData({
                isShow: false
            })
        } else {
            this.setData({
                isShow: true
            })
        }
    }

    // 显示或隐藏弹窗(图片详情)
    handleShow2 = () => {
        if (this.state.isShow2) {
            this.setData({
                isShow2: false
            })
        } else {
            this.setData({
                isShow2: true
            })
        }
    }

    // 显示或隐藏弹窗(进度详情)
    handleShow3 = () => {
        if (this.state.isShow3) {
            this.setData({
                isShow3: false
            })
        } else {
            this.setData({
                isShow3: true
            })
        }
    }

    // 报案状态更新
    changeStatus = (e) => {
        this.setData({
            status: e
        });
        setTimeout(() => {
            this.dataSource(1)
        }, 500);
    }

    // 报案进度状态更新
    changeProgressStatus = (e) => {
        this.setData({
            progress_status: e
        })

        setTimeout(() => {
            this.dataSource(1);
        }, 500);
    }

    // 获取输入框的值
    getInput(e) {
        // console.log(e.target.value);
        this.setData({
            search_value: e.target.value
        })
    }

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {

        this.setState({ data_loding: true });
        const _this = this;
        const { status, progress_status, search_value } = this.state;
        await app.post(api.GetAdminCaseReportList, {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            status, // 报案状态 -1 全部 0 待接收 1 已接收 2 不接受 3 已撤销
            progress_status, // 报案进度 -1 全部 0 待处理 1 进行中 2 已结束未完成 3 已完成
            page,
            search_value,
        }).then(({ flag, data, msg, total }) => {
            if (_this._isMounted) {
                _this.setState({ data_loding: false });
                if (flag === 1) {
                    // console.log(data);
                    _this.setState({ teamList: data.report_list, total, page, });
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    setData = (data) => app.setStateSync(this, data)

    render() {
        const columns = [
            {
                title: '接案队伍',
                dataIndex: 'team_name',
                key: 'team_name',
                width: 200
            },
            {
                title: '报案人',
                dataIndex: 'linkname',
                key: 'linkname',
                width: 120
            },
            {
                title: '联系号码',
                dataIndex: 'mobile',
                key: 'mobile',
                width: 120,
            },
            {
                title: '报案时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: 120
            },
            {
                title: '案发地点',
                dataIndex: 'count',
                key: 'count',
                width: 250,
                render: (text, record) => {
                    return (
                        <div>
                            {record.province}
                            {record.city}
                            {record.area}
                        </div>
                    )
                }
            },
            {
                title: '详细地址',
                dataIndex: 'address',
                key: 'address',
                width: 250,
            },
            {
                title: '报案描述',
                dataIndex: 'desc',
                key: 'desc',
                width: 250
            },
            {
                title: '报案状态',
                dataIndex: 'status_name',
                key: 'status_name',
                width: 120
            },
            {
                title: '案件进度',
                dataIndex: 'progress_status_name',
                key: 'progress_status_name',
                width: 120
            },
            {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: 60,
                render: (id, record) => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <Button size="small" onClick={() => this.getDetail(record.id)}>详情</Button>
                            </div>
                        </div>
                    )
                }
            },
        ], loading = this.state.data_loding,
            teamList = this.state.teamList,
            // { getFieldDecorator, getFieldValue } =  this.props.form,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            };
        const { isShow, isShow2, isShow3, page, total, formItemLayout, detailData, progress_list_reson } = this.state;
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div style={{ marginBottom: 10 }}>案件管理</div>
                </Row>
                <div>
                    <span>报案状态：</span>
                    <Select defaultValue="-1" style={{ width: 120, marginLeft: 10 }}
                        onChange={(e) => this.changeStatus(e)}
                    >
                        <Select.Option value="-1">全部</Select.Option>
                        <Select.Option value="0">待接收</Select.Option>
                        <Select.Option value="1">已接收</Select.Option>
                        <Select.Option value="2">不接受</Select.Option>
                        <Select.Option value="3">已撤销</Select.Option>
                    </Select>
                    <span style={{ marginLeft: 20 }}>报案进度: </span>
                    <Select defaultValue="-1" style={{ width: 200, marginLeft: 10 }}
                        onChange={(e) => this.changeProgressStatus(e)}
                    >
                        <Select.Option value="-1">全部</Select.Option>
                        <Select.Option value="0">待处理</Select.Option>
                        <Select.Option value="1">进行中</Select.Option>
                        <Select.Option value="2">已结束未完成</Select.Option>
                        <Select.Option value="3">已完成</Select.Option>
                    </Select>

                    <Input style={{ width: 250, marginLeft: 20, }} onChange={(e) => this.getInput(e)} placeholder='请输入案件关键词进行搜索' />
                    <Button onClick={() => this.dataSource()} type='primary' style={{ marginLeft: 20 }}>搜索</Button>
                </div>
                <Table className="ranks_table"
                    rowKey="id"
                    size="middle"
                    locale={locale}
                    columns={columns}
                    dataSource={teamList}
                    loading={loading}
                    pagination={{
                        current: page,
                        total,
                        pageSize: 20,
                        showTotal: (t) => `总数量：${t}`,
                        onChange: (e) => this.dataSource(e)
                    }}
                    scroll={{ y: 'calc(100% - 46px)' }}
                />

                <Modal
                    title='案件详情'
                    visible={isShow}
                    footer={false}
                    width={568}
                    onCancel={() => this.handleShow()}
                >
                    <Form
                        {...formItemLayout}
                    >
                        <h1>{detailData.desc}</h1>
                        <Row gutter={18}>
                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">报案人：</span> <span style={{ paddingLeft: 5 }}>{detailData.linkname || ''}</span>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">联系号码：</span> <span style={{ paddingLeft: 5 }}>{detailData.mobile || ''}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={18}>

                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">报案时间：</span> <span style={{ paddingLeft: 5 }}>{detailData.create_time || ''}</span>
                                </div>
                            </Col>
                            <Col span={24}>

                                <div className="detailItem">
                                    <span className="detailItemTitle">案发地点：</span> <span style={{ paddingLeft: 5 }}>{detailData.province || ''}{detailData.city || ''}{detailData.area || ''}</span>
                                </div>

                            </Col>
                        </Row>
                        <div className="detailItem detailItem_dizhi">
                            <span className="detailItemTitle">详细地址：</span> <span style={{ paddingLeft: 5 }}>{detailData.address || ''}</span>
                        </div>
                        {/* <div className="detailItem">
                            <span className="detailItemTitle">报案描述：</span> <span style={{ paddingLeft: 5 }}>{detailData.desc || ''}</span>
                        </div> */}

                        <Row gutter={18}>

                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">报案状态：</span> <span style={{ paddingLeft: 5 }}>{detailData.status_name || ''}</span>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">案件进度：</span> <span style={{ paddingLeft: 5 }}>{detailData.progress_status_name || ''}</span>
                                    <span onClick={() => this.handleShow3()} style={{ display: detailData.status == 1 ? 'inline-block' : 'none', marginLeft: 10, color: '#1890ff', cursor: 'pointer' }}>
                                        查看进度
                                    </span>
                                </div>
                            </Col>
                            <Col span={24} style={{ display: detailData.status == 2 ? 'inline-block' : 'none' }}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">拒绝原因：</span> <span style={{ paddingLeft: 5 }}>{detailData.reason || ''}</span>
                                </div>
                            </Col>
                            <Col span={24} style={{ display: detailData.progress_status == 2 ? 'inline-block' : 'none' }}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">未完成原因：</span> <span style={{ paddingLeft: 5 }}>{progress_list_reson}</span>
                                </div>
                            </Col>
                            <Col span={24} style={{ display: detailData.status == 3 ? 'inline-block' : 'none' }}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">撤销原因：</span> <span style={{ paddingLeft: 5 }}>{detailData.cancel_reason || ''}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={18}>
                            <Col span={24}>
                                <div className="detailItem">
                                    <span className="detailItemTitle">接案队伍：</span> <span style={{ paddingLeft: 5 }}>{detailData.team_name || ''}</span>
                                </div>
                            </Col>
                        </Row>

                        <div className="detailItem2">
                            <span className="detailItemTitle">现场资料：</span>
                            {
                                (detailData.pics || []).map((e, i) => {
                                    return (
                                        <div key={i} className="detailItemImg">
                                            <Avatar onClick={() => this.handleShow2()} shape="square" size={36} src={config.imgUrl + e} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Form>
                </Modal>

                <Modal
                    title={false}
                    visible={isShow2}
                    footer={false}
                    width={768}
                    onCancel={() => this.handleShow2()}
                >
                    <Carousel
                        autoplay={false}//是否自动切换
                        infinite={false}//是否循环播放
                        dots={true} //是否显示面板指示点
                    >
                        {
                            (detailData.pics || []).map((e, i) => {
                                return (
                                    <img key={i} className="detailImg" src={config.imgUrl + e} alt="" ></img>
                                )
                            })
                        }
                    </Carousel>
                </Modal>

                <Modal
                    title='案件进度'
                    visible={isShow3}
                    footer={false}
                    onCancel={() => this.handleShow3()}
                >
                    <div className="wrapper">
                        <div className="content">
                            {
                                (detailData.progress_list || []).map((item, index) => {
                                    return (
                                        <div className="box" key={index + item}>
                                            <div className="item">
                                                <div
                                                    style={{ display: item.progress_status == '0' ? 'inline-block' : 'none' }}
                                                    className={item.progress_status == '0' ? 'status font600 c0' : 'status font600'}
                                                >
                                                    {item.progress_status_name2 || '-'}
                                                </div>
                                                <div
                                                    style={{ display: item.progress_status == '1' ? 'inline-block' : 'none' }}
                                                    className={item.progress_status == '1' ? 'status font600 c1' : 'status font600'}
                                                >
                                                    {item.progress_status_name2 || '-'}
                                                </div>
                                                <div
                                                    style={{ display: item.progress_status == '2' ? 'inline-block' : 'none' }}
                                                    className={item.progress_status == '2' ? 'status font600 c2' : 'status font600'}
                                                >
                                                    {item.progress_status_name2 || '-'}
                                                </div>
                                                <div
                                                    style={{ display: item.progress_status == '3' ? 'inline-block' : 'none' }}
                                                    className={item.progress_status == '3' ? 'status font600 c3' : 'status font600'}
                                                >
                                                    {item.progress_status_name2 || '-'}
                                                </div>
                                                <div className="date">{item.create_time || '-'}</div>
                                            </div>
                                            <div className="item">
                                                <div className="option ">操作人：{item.vname || '-'}</div>
                                            </div>
                                            <div className="item" style={{ display: item.desc != null && item.desc != '' ? 'inline-block' : 'none' }}>
                                                <div className="desc ">案件记录：{item.desc}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Modal>

            </div>
        );
    }
}

export default CaseAdmin;



// WEBPACK FOOTER //
// ./src/routes/ranks/CaseAdmin.jsx